export default "__VITE_ASSET__aLEgFls5__"